/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Oscoachtel2Inputs */

const de__field_oscoachtel2 = /** @type {(inputs: _Field_Oscoachtel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS-Coach Telefonnummer`)
};

/**

* @param {_Field_Oscoachtel2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_oscoachtel2 = /** @type {((inputs?: _Field_Oscoachtel2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Oscoachtel2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_oscoachtel2(inputs)
});
export { _field_oscoachtel2 as "_field_osCoachTel" }